import { render, staticRenderFns } from "./PdfSlider.vue?vue&type=template&id=2c956a98&lang=pug&"
import script from "./PdfSlider.vue?vue&type=script&lang=ts&"
export * from "./PdfSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c956a98')) {
      api.createRecord('2c956a98', component.options)
    } else {
      api.reload('2c956a98', component.options)
    }
    module.hot.accept("./PdfSlider.vue?vue&type=template&id=2c956a98&lang=pug&", function () {
      api.rerender('2c956a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/PdfSlider.vue"
export default component.exports